import ajax from "./ajax";

export function getCategory() {
  return ajax(`/categories?sort=display_order&per-page=1000`);
}
